import { Logo } from './Logo';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { Button } from './ui/button';
import { Mail, Phone, MapPin, Instagram, Music2, MessageCircle } from 'lucide-react';

export default function Footer() {
  const y = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post('/newsletter', { email });
      toast.success(data.already ? 'Vous êtes déjà inscrit(e)' : 'Inscription confirmée ✨ — un e-mail de bienvenue arrive. Une question ? contactjotaly@gmail.com');
      setEmail('');
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Email invalide');
    } finally { setBusy(false); }
  };

  return (
    <footer className="mt-12 border-t border-black/10 bg-[#E5E7EB] text-black" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-4 shrink-0">
          <Link to="/"><Logo /></Link>
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[13px] whitespace-nowrap" data-testid="footer-nav">
          <Link to="/" className="text-black hover:text-black/60 font-medium" data-testid="footer-home">Accueil</Link>
          <Link to="/shop" className="text-black hover:text-black/60 font-medium" data-testid="footer-shop">Boutique</Link>
          <Link to="/comment-ca-marche" className="text-black hover:text-black/60 font-medium" data-testid="footer-how">Comment ça marche</Link>
          <Link to="/about" className="text-black hover:text-black/60 font-medium" data-testid="footer-about">À propos</Link>
          <Link to="/faq" className="text-black hover:text-black/60 font-medium" data-testid="footer-faq">FAQ</Link>
          <Link to="/contact" className="text-black hover:text-black/60 font-medium" data-testid="footer-contact">Contact</Link>
          <Link to="/register" className="text-black hover:text-black/60 font-medium" data-testid="footer-register">Devenir vendeur</Link>
        </nav>
        <form onSubmit={subscribe} data-testid="newsletter-form" className="flex items-center gap-2 shrink-0">
          <input data-testid="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com"
            className="w-40 sm:w-48 px-3 py-2 rounded-full bg-white border border-black/15 text-black placeholder-slate-400 focus:border-black outline-none text-sm" />
          <Button disabled={busy} type="submit" data-testid="newsletter-submit" className="btn-yellow rounded-full font-bold text-xs h-9 px-4">S'abonner</Button>
        </form>
        <div className="flex items-center gap-2 shrink-0">
          <a href="mailto:contactjotaly@gmail.com" data-testid="footer-email" aria-label="Email" className="h-9 w-9 grid place-items-center rounded-full bg-[#FFD400] text-black hover:bg-black hover:text-[#FFD400] transition-colors"><Mail className="h-4 w-4" /></a>
          <a href="tel:+33783170963" data-testid="footer-phone" aria-label="Téléphone" className="h-9 w-9 grid place-items-center rounded-full bg-[#FFD400] text-black hover:bg-black hover:text-[#FFD400] transition-colors"><Phone className="h-4 w-4" /></a>
          <a href="https://wa.me/33783170963" target="_blank" rel="noreferrer" data-testid="social-whatsapp" aria-label="WhatsApp" className="h-9 w-9 grid place-items-center rounded-full bg-[#FFD400] text-black hover:bg-black hover:text-[#FFD400] transition-colors"><MessageCircle className="h-4 w-4" /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="social-ig" aria-label="Instagram" className="h-9 w-9 grid place-items-center rounded-full bg-[#FFD400] text-black hover:bg-black hover:text-[#FFD400] transition-colors"><Instagram className="h-4 w-4" /></a>
          <a href="https://tiktok.com" target="_blank" rel="noreferrer" data-testid="social-tiktok" aria-label="TikTok" className="h-9 w-9 grid place-items-center rounded-full bg-[#FFD400] text-black hover:bg-black hover:text-[#FFD400] transition-colors"><Music2 className="h-4 w-4" /></a>
        </div>
      </div>
      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 text-xs text-black/60 flex flex-wrap items-center justify-between gap-2">
          <span className="inline-flex items-center gap-1.5"><MapPin className="h-3 w-3" />© {y} JOTALY · Dakar, Sénégal</span>
          <span className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-black" data-testid="footer-terms">CGU</Link>
            <Link to="/privacy" className="hover:text-black" data-testid="footer-privacy">Confidentialité</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
